import { Mark } from "./Navbar";

const Footer = ({ backLinkHref = "#home", backLinkText = "Back to top" }) => {
  return (
    <footer>
      <Mark />
      <div className="footer-left">
        <p>Netherlands · Working worldwide</p>
        <p>© {new Date().getFullYear()} Zaki Creative Studio</p>
      </div>
      <div className="footer-social">
        <a
          href="https://x.com/zakistudionl?s=11&t=CaHhM_wZ5fFofwIsyVU4_g"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="X"
          title="X"
        >
          <i className="fa-brands fa-x-twitter" aria-hidden="true" />
        </a>
        <a
          href="https://www.instagram.com/zakistudionl?igsh=cWhhYXRleGk5czEw"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Instagram"
          title="Instagram"
        >
          <i className="fab fa-instagram" aria-hidden="true" />
          <span className="visually-hidden">Instagram</span>
        </a>
        <a
          href="https://www.tiktok.com/@zakistudionl"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="TikTok"
          title="TikTok"
        >
          <i className="fab fa-tiktok" aria-hidden="true" />
          <span className="visually-hidden">TikTok</span>
        </a>
        <a href="" aria-label="Facebook" title="Facebook">
          <i className="fab fa-facebook-f" aria-hidden="true" />
          <span className="visually-hidden">Facebook</span>
        </a>
      </div>
      <a href={backLinkHref}>
        {backLinkText} <i className="fa-solid fa-arrow-up" aria-hidden="true" />
      </a>
    </footer>
  );
};

export default Footer;
